<template>
    <validation-provider :tag="customTag" :rules="rules" v-slot="validationContext" :name="myId">
        <b-form-group class="formGroup" :class="{ 'smallFG': small }" :id="`input-group-${myId}`" :label="label"
            label-sr-only v-bind="formGroupCols">
            <slot :state="getValidationState(validationContext)"></slot>
            <default-form-invalid-feedback keepHeight :vc="validationContext"></default-form-invalid-feedback>
        </b-form-group>
    </validation-provider>
</template>

<script>
import DefaultFormInvalidFeedback from '@/components/shared/DefaultFormInvalidFeedback.vue'
import { FormGroupDefaultCols } from '@/types/form-default-props'
import { ValidationProvider } from 'vee-validate'

export default {
    components: { DefaultFormInvalidFeedback, ValidationProvider },
    props: {
        rules: {
            type: String,
            default: 'required'
        },
        label: {
            type: String,
            default: 'Input Sem Nome'
        },
        customTag: {
            type: String,
            default: 'span'
        },
        small: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            formGroupCols: FormGroupDefaultCols,
            myId: null,
        }
    },
    computed: {
        myLabel() {
            return `${this.label}${this.rules.includes('required') ? ' *' : ''}`
        }
    },
    methods: {
        dec2hex(dec) {
            return dec.toString(16).padStart(2, "0")
        },
        generateId(len) {
            var arr = new Uint8Array((len || 40) / 2)
            window.crypto.getRandomValues(arr)
            return Array.from(arr, this.dec2hex).join('')
        },
        getValidationState({ dirty, validated, valid = null }) {
            return dirty || validated ? valid : null;
        }
    },
    created() {
        this.myId = this.generateId(10)
    }
}
</script>
<style scoped>
.smallFG {
    margin-bottom: 0;
}
</style>